import { useMutation } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

export interface ICreateProjectSupplier {
    ProjectId: string;
    SupplierId: string;
    SelectionType?: "manual" | "auto";
}

export interface IProjectSupplier {
    Id: string;
    ProjectId: string;
    SupplierId: string;
    SupplierName: string;
    SelectionType: "manual" | "auto";
    SelectedAt: string;
    CreatedAt: string;
    UpdatedAt: string;
}

export default function useProjectSuppliers() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useCreate() {
        return useMutation({
            mutationFn: (parameters: ICreateProjectSupplier) =>
                axiosPrivate.post(`/v1/project-suppliers/create`, parameters).then(parseSuccessResponseData),
        });
    }

    function useList() {
        return useMutation({
            mutationFn: (params: { ProjectId: string }) =>
                axiosPrivate.get(`/v1/project-suppliers/list`, { params }).then(parseSuccessResponseData),
        });
    }

    function useDelete() {
        return useMutation({
            mutationFn: (params: { id: string }) =>
                axiosPrivate.delete(`/v1/project-suppliers/delete/${params.id}`).then(parseSuccessResponseData),
        });
    }

    function useListWithInventory() {
        return useMutation({
            mutationFn: (params: { ProjectId: string }) =>
                axiosPrivate
                    .get(`/v1/project-suppliers/with-inventory?ProjectId=${params.ProjectId}`)
                    .then(parseSuccessResponseData),
        });
    }

    return { useCreate, useList, useDelete, useListWithInventory };
}
